<div class="flex justSpaceBetween mbs">
  <h1 class="pbm">Planer</h1>

  <button 
    kendoButton 
    fillMode="outline"
    size="small"
    rounded="large"
    themeColor="dark"
    class="floatRight hide-mobile"
    [hidden]="!('Permissions.Assignments.Search' | permission) || !('Permissions.SchedulerItems.Create' | permission)"
    (click)="showAssigmentList = !showAssigmentList">{{showAssigmentList ? 'Auftragsliste ausblenden' : 'Auftragsliste anzeigen'}}</button>
</div>


<app-scheduler-shared
  [showAssigmentList]="showAssigmentList"
  [events]="events"
  [holidays]="holidays"
  [schedulerRessources]="schedulerRessources"
  [searchRequest]="listSchedulerItemsRequest"
  [absenceGroups]="absenceGroups"
  [isLoading]="isLoading"
  (onReloadEvents)="onReloadEvents()"
></app-scheduler-shared>